import type { SVGProps } from 'react';

import * as styles from './LegacySellABusinessIcon.css';

export const LegacySellABusinessIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    className={styles.dollarIcon}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 15 15"
    // xml:space="preserve"
  >
    <path
      d="M12.8,5.2c0.1,0.3,0.3,0.7,0.3,1.1c0.1,0.4,0.1,0.7,0.1,1.1c0,0.4,0,0.7-0.1,1.1c-0.1,0.4-0.2,0.7-0.3,1.1
      c-0.1,0.3-0.3,0.6-0.5,0.9c-0.2,0.3-0.4,0.6-0.7,0.8c-0.3,0.3-0.5,0.5-0.8,0.7s-0.6,0.4-0.9,0.5c-0.3,0.1-0.7,0.3-1.1,0.3
      c-0.4,0.1-0.7,0.1-1.1,0.1s-0.7,0-1.1-0.1c-0.4-0.1-0.7-0.2-1.1-0.3c-0.3-0.1-0.6-0.3-0.9-0.5c-0.3-0.2-0.6-0.4-0.8-0.7
      c-0.3-0.3-0.5-0.5-0.7-0.8c-0.2-0.3-0.4-0.6-0.5-0.9C2.4,9.2,2.3,8.8,2.2,8.5C2.2,8.1,2.1,7.7,2.1,7.4c0-0.4,0-0.7,0.1-1.1
      c0.1-0.4,0.2-0.7,0.3-1.1c0.1-0.3,0.3-0.6,0.5-0.9C3.3,4,3.5,3.7,3.7,3.4S4.3,3,4.6,2.8c0.3-0.2,0.6-0.4,0.9-0.5
      C5.9,2.1,6.2,2,6.6,1.9c0.4-0.1,0.7-0.1,1.1-0.1s0.7,0,1.1,0.1C9.2,2,9.5,2.1,9.8,2.3c0.3,0.1,0.6,0.3,0.9,0.5
      c0.3,0.2,0.6,0.4,0.8,0.7c0.3,0.3,0.5,0.5,0.7,0.8C12.5,4.6,12.7,4.9,12.8,5.2z M10.9,10.5c0.4-0.4,0.7-0.9,1-1.5
      c0.2-0.5,0.3-1.1,0.3-1.7c0-0.6-0.1-1.2-0.3-1.7c-0.2-0.5-0.6-1-1-1.5c-0.4-0.4-0.9-0.8-1.5-1C8.9,3,8.3,2.9,7.7,2.9
      C7.1,2.9,6.5,3,6,3.2c-0.5,0.2-1,0.6-1.5,1c-0.4,0.4-0.8,0.9-1,1.5C3.3,6.2,3.2,6.8,3.2,7.4c0,0.6,0.1,1.2,0.3,1.7
      c0.2,0.5,0.6,1,1,1.5c0.4,0.4,0.9,0.7,1.5,1c0.5,0.2,1.1,0.3,1.7,0.3c0.6,0,1.2-0.1,1.7-0.3S10.4,11,10.9,10.5z M8,7
      C8.2,7,8.4,7.1,8.6,7.2C8.7,7.3,8.9,7.4,9,7.5c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.2,0.1,0.3,0.1,0.5s0,0.4-0.1,0.5
      C9.2,9.2,9.1,9.3,9,9.4C8.9,9.5,8.7,9.6,8.6,9.7S8.3,9.8,8.1,9.8v0.5c0,0,0,0.1,0,0.1s-0.1,0-0.1,0H7.5c0,0-0.1,0-0.1,0
      c0,0,0-0.1,0-0.1V9.8C7.2,9.8,7,9.8,6.9,9.7S6.6,9.5,6.5,9.4C6.4,9.3,6.3,9.1,6.2,8.9S6.1,8.6,6.1,8.3c0,0,0,0,0,0c0,0,0,0,0,0l0,0
      c0,0,0,0,0-0.1c0,0,0,0,0.1,0h0.6c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1c0,0.1,0,0.3,0,0.4c0,0.1,0.1,0.2,0.1,0.2C7.3,9,7.3,9,7.4,9
      c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0C8.1,9,8.2,9,8.3,8.9c0.1-0.1,0.1-0.1,0.1-0.2c0-0.1,0-0.2,0-0.2c0-0.1,0-0.1,0-0.2
      S8.3,8.1,8.3,8.1C8.2,8,8.1,8,8,7.9C7.9,7.9,7.8,7.8,7.7,7.7C7.5,7.7,7.3,7.6,7.1,7.5C6.9,7.4,6.8,7.3,6.6,7.2
      C6.5,7.1,6.4,6.9,6.4,6.8C6.3,6.6,6.3,6.4,6.3,6.2c0-0.2,0-0.4,0.1-0.5c0.1-0.2,0.1-0.3,0.3-0.4C6.7,5.2,6.8,5.1,7,5
      s0.3-0.1,0.4-0.2V4.3c0,0,0-0.1,0-0.1c0,0,0.1,0,0.1,0H8c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v0.6c0.2,0,0.3,0.1,0.5,0.2S8.9,5.2,9,5.4
      s0.2,0.3,0.2,0.5C9.3,6,9.3,6.2,9.3,6.5c0,0,0,0.1,0,0.1s-0.1,0-0.1,0H8.5c0,0-0.1,0-0.1,0s0-0.1,0-0.1c0-0.1,0-0.2,0-0.3
      c0-0.1-0.1-0.2-0.1-0.3C8.2,5.8,8.1,5.7,8,5.7c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1,0.1-0.2,0.1
      C7.3,5.8,7.2,5.9,7.2,6c0,0.1,0,0.2,0,0.3c0,0.1,0,0.1,0,0.2s0.1,0.1,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.2C7.7,6.9,7.8,6.9,8,7z"
    />
  </svg>
);
